<template>
  <div>
    <script
      v-if="project == 'ticketak'"
      v-html="metaWebsite"
      type="application/ld+json"
    ></script>
    <script
      v-if="project == 'ticketak'"
      v-html="metaOrganization"
      type="application/ld+json"
    ></script>

    <!-- <landingBanner :bannerList="Banners" :bannerName="SomeValue" /> -->
    <section class="section-banner">
      <Slick ref="bannerSlick" :options="homeSlider">
        <div>
          <div class="bannerContainer">
            <!-- <router-link to v-on:click.native="redeemvoucher"> -->
            <img :src="VoucherData.bannerimageweb" class alt />
            <!-- </router-link> -->
          </div>
        </div>
      </Slick>
    </section>

    <section class="wrapper pt-0">
      <div class="col-12 col-lg-12 col-xl-11 mx-auto px-0">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <section>
              <div class="select-seat-section mt-5">
                <div class="container px-2 px-md-3">
                  <p>{{ VoucherData.one }}</p>
                  <!-- SHOW THIS DIV FOR MYTIKETI  -->
                  <div
                    v-if="project == 'wanasatime'"
                    class="select-seat-container"
                  >
                    <div>
                      <!-- disableSeats -->
                      <div>
                        <h6 class="mb-3">Please select number of vouchers.</h6>
                        <ul class="select-seat-list mb-3">
                          <!-- <li v-for="(number, index) in numberofSeatsArray" :key="index"> -->

                          <li v-for="(number, index) in 10" :key="index">
                            <span
                              v-if="number == totalNumberOfSeats"
                              class="selected"
                              v-on:click="editNumberOfSeats(number)"
                              >{{ number }}</span
                            >
                            <span
                              v-else
                              v-on:click="editNumberOfSeats(number)"
                              >{{ number }}</span
                            >
                          </li>
                        </ul>
                      </div>
                      <div class="row">
                        <div class="col-md-6 mb-2 mb-md-0">
                          <input
                            name="email"
                            v-on:keyup="onKeyUp($event, 'email')"
                            v-model="userDetails.email"
                            type="text"
                            placeholder="Enter Your Email Address"
                            class="form-control"
                          />
                          <div class="fs-12 text-danger my-2">
                            <span
                              v-if="
                                userDetails.email != '' && !status.emailStatus
                              "
                              >Please enter correct email address.</span
                            >
                          </div>
                        </div>

                        <div class="col-md-6 mb-2 mb-md-0">
                          <div class="row mx-0 align-items-center">
                            <div class="col-3 px-0 country-code-drop">
                              <b-dropdown
                                v-if="CountryCodeList.length > 0"
                                class="pc-input form-control"
                                :text="'+' + DefaultCountryCode"
                                variant="default"
                                slot="append"
                              >
                                <b-dropdown-item
                                  class
                                  v-on:click="onChangeCountry(country)"
                                  v-for="(country,
                                  countryIndex) in CountryCodeList"
                                  :key="countryIndex"
                                  >{{ country.CountryName }} (+{{
                                    country.CountryISOCode
                                  }})</b-dropdown-item
                                >
                              </b-dropdown>
                            </div>

                            <div class="col-9 pl-2 px-0 pr-0 pr-xl-2">
                              <input
                                name="Phone Number"
                                v-on:keyup="onKeyUp($event, 'mobile')"
                                v-model="userDetails.phoneNumber"
                                type="number"
                                placeholder="Enter Your Contact Number"
                                class="form-control"
                              />
                            </div>
                          </div>
                          <div class="fs-12 text-danger my-2">
                            <span
                              v-if="
                                userDetails.phoneNumber != '' &&
                                  !status.phoneNumberStatus
                              "
                              >Mobile number must be 10 digit long.</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-12">
                          <div class="d-flex align-items-center mb-3">
                            <input
                              v-on:change="onKeyUp($event, 'conditions')"
                              v-model="conditions"
                              type="checkbox"
                              id="guestCheckoutTerms"
                            />
                            <label for="guestCheckoutTerms" class="mb-0">
                              I accept the
                              <router-link
                                target="_blank"
                                to="/tnc"
                                class="text-blue"
                              >
                                &nbsp;
                                <u>Terms & Conditions</u>
                              </router-link>
                            </label>
                          </div>
                        </div>
                      </div>
                      <p class="fs-11 mb-0 mt-2">
                        <strong>{{ VoucherData.two }}</strong>
                      </p>
                      <button
                        v-on:click="paynow()"
                        :disabled="
                          totalNumberOfSeats > 0 &&
                          status.phoneNumberStatus &&
                          status.emailStatus &&
                          conditions
                            ? false
                            : true
                        "
                        :class="
                          totalNumberOfSeats > 0 &&
                          status.phoneNumberStatus &&
                          status.emailStatus &&
                          conditions
                            ? 'active'
                            : ''
                        "
                        class="btn-confirm mt-2"
                      >
                        PAY NOW ({{ VoucherData.currency }} {{ total }})
                      </button>
                    </div>
                    <!-- SHOW THIS DIV FOR TICKETAK ENDS -->
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-5">
            <div class="container px-2 px-md-3">
              <p>
                <strong>Terms & Conditions</strong>
              </p>
              <div v-html="VoucherData.t_c"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="wrapper pt-0 d-none">
      <div class="col-12 col-lg-12 col-xl-11 mx-auto px-0">
        <div class="section-menu mb-3 sticky-custom-movie-topbar">
          <div class="section-title d-none d-md-block">Movies</div>
          <ul class="status-filter">
            <li
              class
              v-bind:class="{
                active:
                  visibleShows.title == 'Now Showing' ||
                  !visibleShows.hasOwnProperty('title')
              }"
              v-on:click="
                visibleShows = {
                  show: [...Shows[0].show, ...Shows[1].show]
                }
              "
            >
              Now Showing
            </li>
            <li
              class
              v-if="project != 'wanasatime'"
              v-bind:class="{ active: visibleShows.title == 'Alternate' }"
              v-on:click="visibleShows = Shows[1]"
            >
              Alternate
            </li>
            <li
              class
              v-bind:class="{ active: visibleShows.title == 'Coming Soon' }"
              v-on:click="visibleShows = Shows[2]"
            >
              Coming Soon
            </li>
          </ul>
        </div>

        <div class="row">
          <div
            class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 d-none d-md-block h-100"
            :class="isIE == true ? '' : 'sticky-custom-movie'"
          >
            <!-- <section class="filter-modal"> -->
            <div class>
              <div
                class="accordian-container"
                v-for="(filter, filterKey) in filters"
                :key="filterKey"
              >
                <button
                  :class="
                    selectedFilter &&
                    selectedFilter[filter.filter_key] &&
                    selectedFilter[filter.filter_key].length > 0
                      ? 'active'
                      : ''
                  "
                  class="btn-accordian no-focus"
                  @click="onToggle(filter.collapseId)"
                >
                  <img :src="filter.icon" height="15px" width="15px" />
                  {{ filter.filter_name }}
                </button>
                <b-collapse
                  class="accordian-container"
                  accordion="my-accordion"
                  role="tabpanel"
                  :id="filter.collapseId"
                >
                  <div
                    class="btn-accordian-child d-flex align-items-center"
                    v-for="(filterList, filterListKey) in filter.all_filter"
                    :key="filterListKey"
                  >
                    <input
                      v-on:click="
                        onClickFilter(
                          filter.filter_key,
                          filterList.value,
                          filterListKey,
                          filterList.title
                        )
                      "
                      :id="filter.filter_key + filterListKey"
                      type="checkbox"
                    />
                    <label
                      class="mb-0"
                      :for="filter.filter_key + filterListKey"
                      >{{ filterList.title }}</label
                    >
                  </div>

                  <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
                  </ul>-->
                </b-collapse>
              </div>
            </div>

            <Advertise v-if="project == 'ticketak'" />
            <!-- </section> -->
          </div>

          <div
            class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 d-none h-100 sticky-custom"
          >
            <!-- ALL LOCATIONS FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.locations class="btn-accordian">
                <img
                  src="@/assets/img/location-pin.png"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.locations.selected.Title }}
              </button>
              <b-collapse class="btn-accordian-content" id="locations">
                <button
                  v-b-toggle.locations
                  v-for="(location, locationListIndex) in dropDowns.locations
                    .list"
                  :key="locationListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(location, 'location')"
                >
                  {{ location.Title }}
                </button>
              </b-collapse>
            </div>

            <!-- ALL LANGUAGES FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.languages class="btn-accordian">
                <img
                  src="@/assets/img/svg/icon-world.svg"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.languages.selected.LanguageName }}
              </button>
              <b-collapse class="btn-accordian-content" id="languages">
                <button
                  v-b-toggle.languages
                  v-for="(lang, languageListIndex) in dropDowns.languages.list"
                  :key="languageListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(lang, 'language')"
                >
                  {{ lang.LanguageName }}
                </button>
              </b-collapse>
            </div>

            <!-- ALL GENERE FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.genre class="btn-accordian">
                <img
                  src="@/assets/img/icon-genre.png"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.genre.selected.Genre }}
              </button>
              <b-collapse class="btn-accordian-content" id="genre">
                <button
                  v-b-toggle.genre
                  v-for="(genre, genreListIndex) in dropDowns.genre.list"
                  :key="genreListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(genre, 'genre')"
                >
                  {{ genre.Genre }}
                </button>
              </b-collapse>
            </div>

            <!-- EXPERIENCE FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.experience class="btn-accordian">
                <img
                  src="@/assets/img/icon-format.png"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.experience.selected.Format }}
              </button>
              <b-collapse class="btn-accordian-content" id="experience">
                <button
                  v-b-toggle.experience
                  v-for="(experience, ExperienceListIndex) in dropDowns
                    .experience.list"
                  :key="ExperienceListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(experience, 'experience')"
                >
                  {{ experience.Format }}
                </button>
                <!-- <button v-b-toggle.genre class="btn-accordian-child">2D</button>
                <button v-b-toggle.genre class="btn-accordian-child">3D</button>
                <button v-b-toggle.genre class="btn-accordian-child">4D</button>
                <button v-b-toggle.genre class="btn-accordian-child">4DX</button>-->
              </b-collapse>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-10">
            <div>
              <ul class="list-inline">
                <li
                  v-for="(filter, filterKey) in filtersChips"
                  :key="filterKey"
                  class="list-inline-item"
                >
                  <div class="badge badge-pill bg-pink text-white">
                    {{ filter.title }}
                    <button
                      v-on:click="
                        onRemoveFilterChips(
                          filter.filter_key,
                          filter.value,
                          filterKey
                        )
                      "
                      class="btn-badge-close"
                    >
                      x
                    </button>
                  </div>
                </li>
                <li v-if="filtersChips.length > 0" class="list-inline-item">
                  <div class="badge badge-pill bg-pink text-white">
                    Clear All
                    <button
                      v-on:click="onClearAllFilters()"
                      class="btn-badge-close"
                    >
                      x
                    </button>
                  </div>
                </li>
              </ul>
            </div>
            <div class="row movie-listing">
              <div
                v-for="(movie, index222) in visibleShows.show"
                :key="index222"
                class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4"
              >
                <router-link
                  :to="{
                    name: 'movie',
                    params: {
                      movieID: movie.id,
                      cinemaID: '0',
                      props: { selectedFilter, cat_id: visibleShows['cat_id'] }
                    }
                  }"
                >
                  <div class="movie-card">
                    <span
                      v-if="movie.flagname.length > 0"
                      class="advance-booking"
                      >{{ movie.flagname }}</span
                    >
                    <img v-lazy="movie.movie_card_img" class="movie-poster" />
                    <div class="movie-content">
                      <div class="movie-name">{{ movie.title }}</div>
                      <div class="d-flex flex-wrap">
                        <div class="fs-14 text-dark">
                          <span>{{ movie.rated }}</span>
                          <span>|</span>
                          <span>{{ movie.genre }}</span>
                          <span>|</span>
                          <span>{{ movie.lang }}</span>
                          <span>|</span>
                          <span class="format">{{ movie.format }}</span>
                        </div>
                      </div>
                      <div
                        v-if="visibleShows.title == 'Coming Soon'"
                        class="d-done d-flex flex-wrap mb-3 mb-md-0"
                      >
                        <div
                          class="movie-release mr-2 d-flex align-items-center"
                        >
                          <!-- <img
                            src="@/assets/img/icon-calender.png"
                            class="mr-1"
                            height="15px"
                            width="15px"
                          />-->
                          <span class="fs-14 text-dark">
                            Release Date:&nbsp;
                            {{ movie.release }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>

              <!-- <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4">
                <router-link to="#">
                  <div class="movie-card">
                    <img src="@/assets/img/alita325.jpg" class="w-100" alt>
                    <div class="movie-content">
                      <div class="movie-name">Alita</div>
                      <div class="d-flex flex-wrap text-dark fpx">
                        <span>English</span>
                        <span class="mx-1">|</span>
                        <span>Genere</span>
                        <span class="mx-1">|</span>
                        <div>
                          <span class="format">2D</span>
                          <span class="format">3D</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>-->
            </div>

            <div>
              <!-- <PromoSlider/> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FIXED BOTTOM BUTTON -->
    <section class="fixed-filter d-none">
      <button
        style="width:100%"
        v-on:click="filterModal = !filterModal"
        class="btn-filter"
      >
        Filter
      </button>
    </section>

    <!-- FILTER MODAL START-->
    <section v-if="filterModal" class="filter-modal d-none">
      <div class="filter-modalContent">
        <nav>
          <img
            src="@/assets/img/svg/arrow-left.svg"
            height="20px"
            width="20px"
            alt="Back"
            v-on:click="filterModal = !filterModal"
          />
          <h6>Filter</h6>
          <a href v-on:click.native="onClearAllFilters()" class="btn-reset"
            >RESET</a
          >
        </nav>

        <div class>
          <div
            class="accordian-container"
            v-for="(filter, filterKey) in filters"
            :key="filterKey"
          >
            <button
              :class="
                selectedFilter &&
                selectedFilter[filter.filter_key] &&
                selectedFilter[filter.filter_key].length > 0
                  ? 'active'
                  : ''
              "
              class="btn-accordian no-focus"
              @click="onToggle(filter.collapseId)"
            >
              <img :src="filter.icon" height="15px" width="15px" />
              {{ filter.filter_name }}
            </button>
            <b-collapse
              class="accordian-container"
              :id="filter.collapseId"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div
                class="btn-accordian-child d-flex align-items-center"
                v-for="(filterList, filterListKey) in filter.all_filter"
                :key="filterListKey"
              >
                <input
                  :id="filter.filter_key + filterListKey"
                  v-on:click="
                    onClickFilter(
                      filter.filter_key,
                      filterList.value,
                      filterListKey,
                      filterList.title
                    )
                  "
                  type="checkbox"
                  :checked="
                    selectedFilter[filter.filter_key] &&
                    filterList.value ==
                      selectedFilter[filter.filter_key][filterListKey]
                      ? true
                      : false
                  "
                />
                <label class="mb-0" :for="filter.filter_key + filterListKey">{{
                  filterList.title
                }}</label>
              </div>

              <!-- <div
                    class="btn-accordian-child d-flex align-items-center"
                    :class="(selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][filterListKey]) ? 'active':''"
                    v-for="(filterList ,filterListKey) in filter.all_filter"
                    v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                    :key="filterListKey"
                  >
                    <label class="mb-0 chkbox active" :for="filter.filter_key+filterListKey">
                      <input :id="filter.filter_key+filterListKey" class="d-none" type="checkbox" />
                    </label>
                    {{filterList.title}}
              </div>-->

              <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
              </ul>-->
            </b-collapse>
          </div>
        </div>

        <div class="btn-container">
          <button
            v-on:click="filterModal = !filterModal"
            class="btn-applyFilter no-focus"
          >
            APPLY FILTER
          </button>
        </div>
      </div>
    </section>
    <!-- FILTER MODAL END -->

    <div class="section-space"></div>
    <!-- Payment Form -->
    <div id="form_sample" class="d-none"></div>
  </div>
</template>

<script>
import Vue from "vue";
import Slick from "vue-slick";
//import carousel from "vue-owl-carousel";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import {
  PROJECT,
  METAWEBSITE,
  METAORGANIZATION,
  metaInfo,
  URL_BASE
} from "@/helper/constant.js";

import QuickBook from "@/components/partials/QuickBook.vue";
import landingBanner from "@/components/partials/mainBanner";
import $ from "jquery";
import { ReferralService } from "@/services/storage.service";
import Advertise from "@/components/partials/advertise.vue";
import { VeeValidate } from "vee-validate";

export default {
  name: "CheckoutVoucher",

  components: {
    Slick,
    QuickBook,
    Advertise,
    landingBanner

    // PromoSlider
  },
  metaInfo: metaInfo,
  data() {
    return {
      isIE: false,
      project: PROJECT,
      metaWebsite: METAWEBSITE,
      metaOrganization: METAORGANIZATION,
      filterModal: false,
      SomeValue: "SomeValue",
      homeSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "3.5%",
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: true,
              centerMode: false,
              slidesToShow: 1,
              autoplaySpeed: 7000,
              autoplay: true,
              slidesToScroll: 1
            }
          }
        ]
      },
      Shows: [],
      AllShows: {
        show: []
      },
      Banners: [],
      visibleShows: [],
      filters: [],
      selectedFilter: {},
      dropDowns: {
        locations: {
          selected: {
            Title: "All Locations"
          },
          list: []
        },
        languages: {
          selected: {
            LanguageName: "All Languages"
          },
          list: []
        },
        cinemaChain: {
          selected: {
            OrganizationName: "All Cinemas"
          },
          list: []
        },
        genre: {
          selected: {
            Genre: "All Genre"
          },
          list: []
        },
        experience: {
          selected: {
            Format: "All Experience"
          },
          list: []
        }
      },
      quickBook: {
        movies: [],
        movieSelected: "",
        cinemaSelected: "",
        dateSelected: "",
        timeSelected: "",
        cinemas: [],
        date: [],
        time: [],
        allData: [],
        filteredData: []
      },
      referralCode: "",
      filtersChips: [],
      totalNumberOfSeats: 0,
      userDetails: {
        email: "",
        phoneNumber: "",
        password: ""
      },
      CountryCodeList: [],
      VoucherData: [],
      DefaultCountryCode: "",
      status: {
        emailStatus: false,
        phoneNumberStatus: false,
        offer: false
      },
      emailCheck: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
      ConfirmationURL: "",
      FailedURL: "",
      BASEURL: URL_BASE,
      conditions: false,
      totalseats: 0,
      total: 0
    };
  },
  beforeMount() {
    // this.getNowShowingData();
    //this.getAllFilters();
    // this.getQuickBookDetails();
    // this.getLanguages();
    this.totalNumberOfSeats = 0;
    this.ConfirmationURL = window.location.origin + "/confirmation";
    this.FailedURL = window.location.origin + "/failedPayment";
  },
  mounted() {
    this.isIE = this.$browserDetect.isIE;
    this.SomeValue = "OtherValue";
    // branch.init("key_live_lgSDutp4w6xV8GnFUq8FYgebxskAtqf9", function(
    //   err,
    //   data
    // ) {
    //   console.log(err, data);
    // });
    //if url is referal, check value
    console.log("this.$route.pathname :", this.$route.path);
    if (this.$route.path.includes("referral")) {
      this.referralCode = this.$route.params.code;
      ReferralService.saveReferral(this.referralCode);
    }
    this.getAllGetCountryList();
    this.getVoucherData();
  },
  methods: {
    onToggle: function(index) {
      this.$root.$emit("bv::toggle::collapse", index);
    },
    onClearAllFilters: function() {
      this.filtersChips = [];
      this.selectedFilter = {};
      this.getNowShowingData();
    },
    onClickFilter: function(filter_key, value, index, title) {
      let __index = this.filtersChips.findIndex(x => x.title === title);

      if (__index > -1) {
        this.filtersChips.splice(__index, 1);
      } else {
        this.filtersChips.push({
          title: title,
          filter_key: filter_key,
          value: value
        });
      }
      let obj = {};
      obj[filter_key] = [];

      this.selectedFilter = {
        ...obj,
        ...this.selectedFilter
      };
      let _index = this.selectedFilter[filter_key].indexOf(value);
      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      } else {
        this.selectedFilter[filter_key].push(value);
      }
      this.getNowShowingData();
    },
    onRemoveFilterChips(filter_key, value, index) {
      this.filtersChips.splice(index, 1);
      let _index = this.selectedFilter[filter_key].indexOf(value);

      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      }
      this.getNowShowingData();
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(" ");
    },
    filterData: function(data, filter) {
      $("html, body").animate(
        {
          scrollTop: $("#quickbook").offset().top
        },
        1000
      );
      if (filter == "language") {
        this.dropDowns.languages.selected = data;
      }
      if (filter == "genre") {
        this.dropDowns.genre.selected = data;
      }
      if (filter == "experience") {
        this.dropDowns.experience.selected = data;
      }
      if (filter == "location") {
        this.dropDowns.locations.selected = data;
      }

      this.getNowShowingData();
    },

    editNumberOfSeats: function(number) {
      this.totalNumberOfSeats = number;
      this.total =
        number *
        (parseInt(this.VoucherData.priceperticket) +
          parseInt(this.VoucherData.ihc));
    },
    onChangeCountry: function(country) {
      this.DefaultCountryCode = country.CountryISOCode;
    },
    getAllGetCountryList: function() {
      makeRequest("/GetCountryCode", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.CountryCodeList = res.data.List;
            this.DefaultCountryCode = res.data.Default.CountryCode;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    getVoucherData: function() {
      this.showLoading();
      makeRequest("/angamovieoffers", "GET", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.VoucherData = res.data;
            //console.log("res.data :", this.VoucherData.bannerimage);
            this.hideLoading();
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
          this.hideLoading();
        });
    },
    onKeyUp: function(event, name) {
      let emailreg = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if (name == "email") {
        if (!emailreg.test(this.userDetails.email)) {
          this.status.emailStatus = false;
        } else {
          this.status.emailStatus = true;
        }
        ///check email validation
      } else if (name == "mobile") {
        if (this.userDetails.phoneNumber.length < 10) {
          this.status.phoneNumberStatus = false;
        } else {
          this.status.phoneNumberStatus = true;
        }
        //check mobile validation
      }
    },
    getAllFilters: function() {
      let payload = {
        FilterType: "Home"
      };
      makeRequest("/GetAllFilter", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            this.filters = [];
            res.data.Filters.map((x, index) => {
              this.filters.push({
                ...x,
                collapseId: "collapse-" + (index + 1)
              });
            });
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    paynow: function() {
      this.showLoading();
      let payload = {
        email: this.userDetails.email,
        mobile: this.userDetails.phoneNumber,
        countrycode: this.DefaultCountryCode,
        noofvoucher: this.totalNumberOfSeats,
        SucessUrl: this.ConfirmationURL,
        FailUrl: this.FailedURL,
        ApiCallURL: this.BASEURL,
        ismobile: 0
      };
      makeRequest("/VoucherPayment", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (res.data.Status) {
            let links = res.data.links;
            var x = document.getElementById("form_sample");
            var createform = document.createElement("form"); // Create New Element Form
            createform.setAttribute("action", links.requestUrl); // Setting Action Attribute on Form
            createform.setAttribute("method", "post"); // Setting Method Attribute on Form
            createform.setAttribute("ref", "submitForm"); // Setting Method Attribute on Form
            createform.setAttribute("name", "submitForm"); // Setting Method Attribute on Form
            x.appendChild(createform);
            let params = links.requestParameter;

            Object.keys(params).map(x => {
              var submitelement = document.createElement("input"); // Append Submit Button
              submitelement.setAttribute("type", "text");
              submitelement.setAttribute("name", x);
              submitelement.setAttribute("value", params[x]);
              createform.appendChild(submitelement);
            });

            var _submitelement = document.createElement("input"); // Append Submit Button
            _submitelement.setAttribute("type", "submit");
            _submitelement.setAttribute("value", "submit");
            createform.appendChild(_submitelement);

            setTimeout(() => {
              document.submitForm.submit();
              this.hideLoading();
              // this.$nextTick(() => {
              //   // this.sessionStore.set("EMRID", this.reserveID);
              //   this.$refs.submitForm.submit();
              // });
            }, 2000);
          }
        })
        .catch(error => {
          // this.$root.$emit("bv::show::modal", "checkoutModal");
          // this.userDetails.errorMessage = "Something went wrong!";
          // console.log("Error on vue front", error);
        });

      // this.$refs.submitForm.submit();
    },
    getNowShowingData: function() {
      this.showLoading();
      this.Shows = [];
      let payload = {
        BannerType: "Home"
      };
      // if (this.dropDowns.locations.selected.Title != "All Locations") {
      //   payload.LocationID = this.dropDowns.locations.selected.LocationID;
      // }
      // if (this.dropDowns.languages.selected.LanguageName != "All Languages") {
      //   payload.MovieLanguageID = this.dropDowns.languages.selected.LanguageID;
      // }
      // if (this.dropDowns.genre.selected.Genre != "All Genre") {
      //   payload.Genre = this.dropDowns.genre.selected.GenreID;
      // }
      // if (this.dropDowns.experience.selected.Format != "All Experience") {
      //   payload.Format = this.dropDowns.experience.selected.FormatID;
      // }
      // payload[]
      Object.keys(this.selectedFilter).map(x => {
        if (this.selectedFilter[x].length > 0) {
          payload[x] = this.selectedFilter[x].toString();
        }
      });
      makeRequest("/GetAllShow", "POST", null, payload)
        .then(response => {
          this.hideLoading();
          const { error, res } = response;
          // console.log("movie", error, res);
          let obj = {
            movie: true,
            movie_card_img: "@/assets/img/aquaman_1475_555.jpg"
          };
          this.totalseats = res.data.MaxTicketLimit;
          this.Shows = res.data.Shows;
          this.Banners = res.data.Banners;
          if (this.project == "ticketak") {
            this.Banners = this.Banners.filter(singleBanner => {
              if (singleBanner.banner.BannerType == "Movie") {
                return singleBanner;
              }
            });
          }
          // this.Banners.push(obj);

          this.Shows.map(shows => {
            shows.show.map(x => {
              x.url = "/movie/" + x.id + "/0";
            });
          });
          this.visibleShows = {
            show: [...this.Shows[0].show, ...this.Shows[1].show]
          };
          this.visibleShows.title = "Now Showing";
          // this.newReleases = res.data.Shows[0].show;
          // this.newReleases.map(x => {
          //   x.url = "/movie/" + x.id;
          // });
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },

    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      console.log("handleAfterChange", event, slick, currentSlide);
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      console.log("handleBeforeChange", event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
      console.log("handleBreakpoint", event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
      console.log("handleDestroy", event, slick);
    },
    handleEdge(event, slick, direction) {
      console.log("handleEdge", event, slick, direction);
    },
    handleInit(event, slick) {
      console.log("handleInit", event, slick);
    },
    handleReInit(event, slick) {
      console.log("handleReInit", event, slick);
    },
    handleSetPosition(event, slick) {
      console.log("handleSetPosition", event, slick);
    },
    handleSwipe(event, slick, direction) {
      console.log("handleSwipe", event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
      console.log("handleLazyLoaded", event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
      console.log("handleLazeLoadError", event, slick, image, imageSource);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/CheckoutVoucher.vue